export const cardData = [
  
  {
    name: "جلسة المساج السويدي للاسترخاء",
    icon: "prog1",
    price: "89",
    pricePromo: "115",
    description: " تجربة تدليك بلطف باستخدام زيوت عطرية دافئة",
     tag:'مساج'
  },
  {
    name: "تجربة المساج الياباني الشياتسو",
    icon: "prog2",
    price: "89",
    pricePromo: "115",
    description: "ضغط بالأصابع على النقاط الحيوية بالجسم لتحفيز تدفق الطاقة وتقليل الإجهاد والآلام العضلية",
     tag:'مساج'
  },
  {
    name: "جلسة المساج التايلاندي لتنشيط الدورة الدموية",
    icon: "prog3",
    price: "99",
    pricePromo: "130",
    description:
      " تمديد الجسم بالكامل باستخدام تقنيات خاصة لتنشيط الدورة الدموية وزيادة مرونة العضلات ",
       tag:'مساج'
  },
  {
    name: "جلسة بديكير العناية الكاملة (يدين وأرجل)",
    icon: "prog4",
    price: "120",
    pricePromo: "170",
    description:
      "تنظيف عميق للقدمين واليدين تقشير الجلد الميت وترطيب البشرة مع تشذيب الأظافر",
       tag:'بديكير'
  },
  {
    name: "الحمام المغربي التقليدي بالصنفرة",
    icon: "prog5",
    price: "89",
    pricePromo: "115",
    description:
      "حمام بالبخار مع صابون بلدي مغربي تقشير الجلد بالصنفرة لإزالة السموم وتجديد البشرة ",
      tag:'حمام'
  },
  {
    name: "الحمام المغربي الملكي بالأعشاب",
    icon: "prog6",
    price: "100",
    pricePromo: "150",
    description:
      "حمام فاخر بالأعشاب الطبيعية، صابون بلدي مغربي، وصنفرة لتنشيط الدورة الدموية وتهدئة الجسم",
      tag:'حمام'
  },
  {
    name: "تنظيف البشرة الأساسي",
    icon: "prog7",
    price: "50",
    pricePromo: "80",
    description:
      "تنظيف البشرة بخطوات بسيطة تشمل التنظيف والتقشير والترطيب للحصول على بشرة نضرة ومشرقة",
      tag:'تنظيف البشرة'
  },
  {
    name: "تنظيف البشرة العميق بالمنتجات الطبيعية",
    icon: "prog8",
    price: "100",
    pricePromo: "150",
    description:
      "تنظيف شامل باستخدام منتجات طبيعية، يشمل البخار، إزالة الرؤوس السوداء، ماسك مهدئ وترطيب عميق",
      tag:'تنظيف البشرة'
  },
  {
    name: "بديكير فخم للعناية بالأرجل",
    icon: "prog9",
    price: "65",
    pricePromo: "100",
    description:
      "نقع القدمين بالماء الدافئ، إزالة الجلد الميت، ترطيب وقص الأظافر للحصول على مظهر صحي ونظيف ",
      tag:'بديكير'
  },
  {
    name: "بديكير فاخر للعناية بالأيدي",
    icon: "prog10",
    price: "55",
    pricePromo: "70",
    description:
      "تنظيف اليدين إزالة الجلد الميت ترطيب البشرة، وقص الأظافر مع إضافة لمسة نهائية لامعة",
      tag:'بديكير'
  },
  {
    name: "إضافة الأحجار الساخنة لتحفيز الاسترخاء",
    icon: "prog11",
    price: "50",
    pricePromo: "115",
    description:
      " وضع أحجار ساخنة على نقاط معينة بالجسم لتخفيف الآلام وزيادة الاسترخاء وتدفئة العضلات",
      tag:'حمام'
  },
  {
    name: "جلسة علاجية بكاسات الهواء",
    icon: "prog12",
    price: "35",
    pricePromo: "40",
    description:
      " استخدام كاسات الهواء لتحفيز تدفق الدم، تقليل التوتر، وعلاج الألم بطريقة طبيعية",
      tag:'مساج'
  },
  {
    name: "حلاقة دقن بتقنيات متطورة",
    icon: "prog13",
    price: "20",
    description:
      "حلاقة دقيقة باستخدام أدوات معقمة، تشمل كريم الحلاقة الفاخر وتدليك الوجه بعد الحلاقة",
      tag:'حلاقة'
  },
  {
    name: "قص شعر بتصفيف عصري",
    icon: "prog14",
    price: "20",
    description:
      "قص شعر بأحدث التصاميم مع مراعاة المظهر الشخصي واستخدام أدوات احترافية لضمان النتائج المثالية",
      tag:'حلاقة'
  },
  {
    name: "إزالة الشعر بالشمع لإطلالة ناعمة",
    icon: "prog15",
    price: "30",
    description:
      "إزالة الشعر غير المرغوب فيه باستخدام الشمع للحصول على بشرة ناعمة ونظيفة",
      tag:'حلاقة'
  },
  {
    name: "تصفيف الشعر القصير بجودة عالية",
    icon: "prog16",
    price: "20",
    description:
      "تجفيف وتصفيف الشعر القصير بمنتجات مخصصة لضمان الثبات والمظهر العصري",
      tag:'حلاقة'
  },
  {
    name: "تصفيف الشعر الطويل باحترافية",
    icon: "prog17",
    price: "25",
    description:
      "تصفيف الشعر الطويل بأسلوب يناسب المناسبة مع استخدام منتجات تغذية وترطيب للشعر",
      tag:'حلاقة'
  },
  
  {
    tag:'حلاقة',
    name: "جلسة صنفرة أو بخار لإشراقة الوجه",
    icon: "prog18",
    price: "20",
    description:
      "إزالة الشوائب والخلايا الميتة باستخدام الصنفرة أو البخار للحصول على بشرة نضرة ونظيفة",
  },
  {
    tag:'حلاقة',
    name: "علاج الشعر بالكيراتين أو البروتين قصير",
    icon: "prog19",
    price: "150",
    description: "تغذية الشعر القصير بالكيراتين وزيادة لمعانه الطبيعي",
  },
  {
    name: "علاج الشعر بالكيراتين أو البروتين طويل",
    icon: "prog20",
    price: "200",
    description:
      "معالجة الشعر الطويل بمنتجات عالية الجودة لإصلاح التلف، تقليل التجعد وتحسين المظهر العام",
      tag:'حلاقة'
  },
  {
    name: "قناع مزدوج للبشرة لمظهر صحي",
    icon: "prog21",
    price: "20",
    description:
      "تطبيق قناعين للبشرة يشمل تنظيف عميق وترطيب مكثف للحصول على بشرة مشدودة ونضرة",
      tag:'حلاقة'
  },
  ]
  